<template>
  <div>
 <!-- Must have the app property -->
  <v-app-bar app><h3>{{customer_name}}</h3></v-app-bar>

  <v-main v-if="!loading && !notfound"> 
    <v-row>
        <v-col cols="8">
            <PaymentForm @recalculate="recalculate" /> 
        </v-col>
        <v-col cols="4">
            <PaymentFormInfo @recalculate="recalculate" />
        </v-col>
    </v-row>

  </v-main>

  <v-main v-if="!loading && notfound"> 
      NOT FOUND
  </v-main>

  </div>
</template>

<script>

import AccountService from '@/services/account'
// @ is an alias to /src
import PaymentForm from '@/components/PaymentForm.vue'
import PaymentFormInfo from '@/components/PaymentFormInfo.vue'


export default {
  name: 'Home',
  components: {
    PaymentForm,
    PaymentFormInfo
  },
  data () {
    return {
        app_name: "",
        loading: true, 
        notfound: false, 
    }
  },
  computed: {
        customer_name() {
            if (this.$store.state.customerName) {
                return this.$store.state.customerName
            }
            return "" 
        },
    },

  methods: {
      recalculate() {
        //console.log( this.$store.state.user_country, this.$store.state.user_account_type )
        AccountService.calculate_price( this.$store.state.subdomain, 
                                        this.$store.state.account_uid, 
                                        this.$store.state.user_country, 
                                        this.$store.state.user_account_type,
                                        this.$store.state.coupon).then((response) => {
            this.$store.state.calculated_price = response.data
            this.$store.state.coupon_valid = response.data.coupon_entry

        })  
      }
  },
  mounted: function () {

    this.$store.state.account_uid = this.$route.params.uid

    //console.log(this.$store.state.subdomain, this.$store.state.account_uid)

    AccountService.get_app_user(this.$store.state.account_uid).then((response) => {
      this.loading = false 

     

      if (response.status == 'error') {
          this.notfound = true
      }
      else {
        this.notfound = false
      
        //console.log("response", response)
        this.$store.state.plan_uid = response.data.plan_uid
        this.$store.state.email = response.data.email
        this.$store.state.account_id = response.data.account_id
        this.$store.state.cus_id = response.data.cus_id
        this.$store.state.cus_exists = response.data.cus_exists
        this.$store.state.cus_data = response.data.cus_data
        this.$store.state.success_url = response.data.success_url
        this.$store.state.cancel_url = response.data.cancel_url

        this.$store.state.subdomain = response.data.subdomain

        this.$store.state.customerName = response.data.app_name

        if (response.data.cus_data && response.data.cus_data.metadata && response.data.cus_data.metadata.country) {
            this.$store.state.user_country = response.data.cus_data.metadata.country
        }

        if (response.data.cus_data && response.data.cus_data.metadata && response.data.cus_data.metadata.account_type) {
            this.$store.state.user_account_type = response.data.cus_data.metadata.account_type
        }

        AccountService.calculate_price(
            this.$store.state.subdomain, 
            this.$store.state.account_uid, 
            this.$store.state.user_country, 
            this.$store.state.user_account_type,
            this.$store.state.coupon).then((response) => {
            this.$store.state.calculated_price = response.data
            console.log("calculate_price", response.data, 
               this.$store.state.subdomain,
                this.$store.state.account_uid,
                this.$store.state.user_country,
                this.$store.state.user_account_type)
        })       
      }
    }) 
    

  }
}
</script>
